<template>
  <div :class="$style.comboBoxContainer">
    <InputValidator
      v-on-clickaway="hideList"
      :config="{
        label: control.label,
        name: control.label,
        validate: control.required ? 'required' : '',
        value: value,
      }"
      :tooltip="getTooltip()"
      @InputValidatorFocus="toggleDropDown"
      @InputValidatorModel="handleChange"
    />
    <DropDownList
      :classNames="classNames"
      :isLargeDropDown="false"
      itemSection="dynamic control combo"
      :menuSections="getDisplayOptions(control)"
      menuFontSize="small"
      :showList="showList"
    />
  </div>
</template>
<script>
import { mixin as clickaway } from 'vue-clickaway';
import DropDownList from 'client/components/DropDownMenu/DropDownList.vue';
import DynamicControlsMixin from 'components/DynamicControls/mixins/DynamicControlsMixin';
import InputValidator from 'client/components/FormValidation/InputValidator.vue';

export default {
  name: 'DynamicControlsComboBox',

  inject: ['$validator'],

  components: {
    DropDownList,
    InputValidator,
  },

  mixins: [
    clickaway,
    DynamicControlsMixin,
  ],

  props: {
    value: {
      default: '',
      type: String,
    },
  },

  data() {
    return {
      classNames: {
        dropDownList: this.$style.dynamicControlsDropDownList,
      },
      showList: false,
    };
  },

  methods: {
    getDisplayOptions(control) {
      const { displayOptions, displayType } = control;
      const displayTypeCaps = displayType.toUpperCase();

      if (displayOptions && displayOptions[displayTypeCaps]) {
        // eslint-disable-next-line
        const options = displayOptions[displayTypeCaps].map(option => {
          return {
            label: option.text,
            action: () => this.handleValueChange(this.control.id, option.value),
          };
        });
        const menuSections = [{ menuItems: options }];
        return menuSections;
      }
      return displayOptions;
    },

    handleChange(value) {
      this.handleValueChange(this.control.id, value);
      this.showList = false;
    },

    hideList() {
      this.showList = false;
    },

    toggleDropDown() {
      if (this.showList) {
        this.showList = false;
      } else {
        this.showList = true;
      }
    },
  },
};
</script>
<style module>
@value (neutral4) from '~css/colors.css';

.comboBoxContainer {
  position: relative;
}

.dynamicControlsDropDownList {
  border-color: neutral4;
  border-radius: 0;
  margin: -12.5px 1px 0 0;
  width: 100%;
}
</style>
